export const redirectToLogin = () => ({ type: "LOGIN_REQUIRED" })
export const storeLastLocation = location => ({
  type: "STORE_LAST_LOCATION",
  payload: { location }
})
